import { render, staticRenderFns } from "./admin.component.vue?vue&type=template&id=857e7fd0&scoped=true"
import script from "./admin.component.vue?vue&type=script&lang=js"
export * from "./admin.component.vue?vue&type=script&lang=js"
import style0 from "./admin.component.vue?vue&type=style&index=0&id=857e7fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857e7fd0",
  null
  
)

export default component.exports